import apiClient from "../baseUrl/axiosConfig";

export const getContactFormSectionHome = async () => {
  const response = await apiClient.get("/pages/home-page");
  return response.data.sections.contact_form_section;
};
